import React from 'react';
import Icon from '../shared/Icon';
import DocumentFieldBlock, { humanizeFieldId } from './DocumentFieldBlock';

/**
 * The flagged fields of the one document being reviewed.
 *
 * An empty flag list is not "done" — a scan too degraded for OCR parks on a
 * document-level tripwire with no field ever measured, so it gets its own copy
 * saying there is nothing here to decide.
 */
const DocumentReviewFields = ({
  doc,
  invalidFields,
  getStagedResolution,
  onStage,
  onStageValue,
  onUnstage,
  onOpenSource,
}) => {
  const flags = doc.flags || [];

  return (
    <div className="docreview-fields">
      {/* No file name or "Document n of N" above the cards — design removed
          both (review feedback 2026-10-06): the selected card in the rail
          already says which document this is. */}
      {/* This copy is right for ONE of the two ways a document parks with no
          flags, and the API cannot yet say which one applies:
            - unreadable scan, nothing measurable  -> "needs a better scan" is correct
            - flags all resolved, release failed   -> it needs releasing, not rescanning
          Backend is adding `park_reason` to the pending-review responses; this
          block should branch on it then. Written for the unreadable case on
          purpose — that is the one where acting on the document is harmful (see
          the `measurable` note in DocumentReviewPanel), so being wrong this way
          sends a reviewer to support rather than releasing something unread. */}
      {flags.length === 0 ? (
        <div className="docreview-unmeasured">
          <Icon name="visibility_off" />
          <p className="docreview-unmeasured-title">No fields could be checked on this document</p>
          <p className="docreview-unmeasured-text">
            The scan was too unclear to read, so no field was measured — there is nothing here
            to confirm or correct. It needs a better scan rather than a review decision.
          </p>
        </div>
      ) : flags.map((flag) => (
        <DocumentFieldBlock
          key={flag.entity_id}
          flag={flag}
          documentId={doc.document_id}
          staged={getStagedResolution(doc.document_id, flag.entity_id)}
          isInvalid={invalidFields.includes(flag.entity_id)}
          onStage={onStage}
          onStageValue={onStageValue}
          onUnstage={onUnstage}
          onOpenSource={(page) => onOpenSource(page, humanizeFieldId(flag.field_id), flag)}
        />
      ))}
    </div>
  );
};

export default DocumentReviewFields;
